import PortfolioMobile from 'components/PortfolioMobile';
import Portfolio from '../../components/Portfolio/index';
import { DataDevyx } from '../../components/Portfolio/data';

export default function Devyx() {
  return (
    <>
      <div className="d-none d-lg-block">
        <Portfolio data={DataDevyx} />
      </div>
      <div className="d-block d-lg-none">
        <PortfolioMobile data={DataDevyx} />
      </div>
    </>
  );
}
